import Table from "../../../../components/tables/Table";
import { ICarrierContactPerState } from "../types";
interface ContactPerStateTableProps {
  data?: ICarrierContactPerState[];
}

const ContactPerStateTable = ({ data }: ContactPerStateTableProps) => {
  const columns = [
    {
      name: "State",
      class: "text-center",
      cell: (row) => row.state,
      sortable: true,
    },
    {
      name: "Contact Type",
      cell: (row) => row.contactTypeName,
      sortable: true,
    },
    {
      name: "E&O Submission Type",
      cell: (row) => row.eAndOName,
      sortable: true,
    },
    {
      name: "Name",
      cell: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      cell: (row) => row.email,
      sortable: true,
    },
    {
      name: "URL",
      cell: (row) => row.url,
      sortable: true,
    },
    {
      name: "Phone Type",
      cell: (row) => row.phoneTypeName,
      sortable: true,
    },
    {
      name: "Phone Number",
      cell: (row) => row.contactNumber,
      sortable: true,
    },
    {
      name: "Extension Number",
      cell: (row) => row.extensionNumber,
      sortable: true,
    },
  ];

  return (
    <div className="mt-5 bg-white text-xs ">
      <Table
        columns={columns}
        data={data}
        loading={false}
        selectableRows={false}
        className={undefined}
        expandableRowsComponent={undefined}
        expandableRowExpanded={undefined}
        clearSelectedRows={undefined}
        onRowExpandToggled={undefined}
        onSelectedRowsChange={undefined}
        setOpenModal={undefined}
      />
    </div>
  );
};
export default ContactPerStateTable;
